import { BasePayloadMapper } from '@ps/utils';

import { AdvancedQualificationsListParams } from '../dtos/advanced-qualification.dto';

const FALLBACK_ADVANCED_TARGETING_LOCALE = 'eng_US';

export type AdvancedQualificationsListPayload = Record<string, string>;

export class AdvancedQualificationsPayloadMapper extends BasePayloadMapper<
  AdvancedQualificationsListParams,
  AdvancedQualificationsListPayload
> {
  public toPayload(
    params: AdvancedQualificationsListParams,
  ): AdvancedQualificationsListPayload {
    const payload: AdvancedQualificationsListPayload = {
      locale: params.locale || FALLBACK_ADVANCED_TARGETING_LOCALE,
    };
    if (params.search) {
      payload['phrase'] = params.search;
    }
    if (params.categoryIds.length) {
      payload['categories'] = params.categoryIds.join(',');
    }
    return payload;
  }
}
